import React from 'react';
import { Button } from './Button';

const IconActionButton = ({
  icon: Icon,
  title,
  label,
  onClick,
  className = '',
  disabled = false,
  size = 'default',
  tone = 'default',
  variant,
  ...props
}) => {
  const buttonTitle = title || label;
  const sizeClass = tone === 'hero'
    ? 'h-9 w-9'
    : size === 'sm'
      ? 'h-7 w-7'
      : 'h-8 w-8';
  const iconClass = tone === 'hero'
    ? 'h-4 w-4'
    : size === 'sm'
      ? 'h-3.5 w-3.5'
      : 'h-4 w-4';

  let toneClass = 'text-gray-500 dark:text-gray-400 hover:text-highlight-600 dark:hover:text-highlight-400 bg-transparent shadow-none';
  if (tone === 'hero') {
    toneClass = 'rounded-lg border border-white/60 bg-white text-teal-800 shadow-md hover:bg-white hover:text-teal-950 hover:shadow-lg disabled:border-white/30 disabled:bg-white/35 disabled:text-white/70 disabled:shadow-none';
  } else if (variant === 'danger') {
    toneClass = 'text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-950/40 bg-white dark:bg-gray-900 border border-red-200 dark:border-red-900/50 shadow-sm hover:shadow';
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      title={buttonTitle}
      aria-label={buttonTitle}
      onClick={onClick}
      disabled={disabled}
      className={`${toneClass} ${sizeClass} ${className}`.trim()}
      {...props}
    >
      {Icon ? <Icon className={`${iconClass} stroke-[2]`} /> : null}
    </Button>
  );
};

export default IconActionButton;
